(function(){
  // === CONFIG ===
  var ORIGIN = { lat: 41.397, lon: -81.725, zip: '44134' }; // Parma/Cleveland

  function timeLabel(h, m){
    var hr12 = ((h + 11) % 12) + 1;
    var ampm = h >= 12 ? 'PM' : 'AM';
    var mm = String(m).padStart(2,'0');
    return hr12 + ':' + mm + ' ' + ampm;
  }
  var CUTOFF = { hour: 17, minute: 30, label: timeLabel(17,30) };
  var HANDLING_MIN_DAYS = 0;
  var HANDLING_MAX_DAYS = 1;
  var HOLIDAYS = new Set(['2025-01-01','2025-05-26','2025-07-04','2025-09-01','2025-11-27','2025-12-25']);
  var US_BANDS = [
    { max: 150,  days: 1 },
    { max: 400,  days: 2 },
    { max: 800,  days: 3 },
    { max: 1400, days: 4 },
    { max: 99999,days: 5 }
  ];

  // === ZIP3 coordinate overrides (adds missing prefixes) ===
var ZIP3_OVERRIDES = {
  "156": [40.33, -79.62], // Greensburg / Jeannette, PA
  "142": [42.89, -78.87], // Buffalo, NY
  // Add more as needed: "605": [41.55, -88.08] etc.
};


  // === HELPERS ===
  function $(sel){ return document.querySelector(sel); }
  function pad(n){ return String(n).padStart(2,'0'); }
  function ymd(d){ return d.getFullYear()+'-'+pad(d.getMonth()+1)+'-'+pad(d.getDate()); }
  function isWeekend(d){ return d.getDay()===0 || d.getDay()===6; }
  function isHoliday(d){ return HOLIDAYS.has(ymd(d)); }
  function isBiz(d){ return !isWeekend(d) && !isHoliday(d); }
  function nextBiz(d){ var x = new Date(d); do { x.setDate(x.getDate()+1); } while(!isBiz(x)); return x; }
  function addBiz(start, days){ var d = new Date(start); while(days-- > 0){ d = nextBiz(d); } return d; }
  function toRad(a){ return a*Math.PI/180; }
  function haversineMi(lat1, lon1, lat2, lon2){
    var R = 3958.7613;
    var dLat = toRad(lat2 - lat1);
    var dLon = toRad(lon2 - lon1);
    var a = Math.sin(dLat/2)**2 + Math.cos(toRad(lat1))*Math.cos(toRad(lat2))*Math.sin(dLon/2)**2;
    return 2 * R * Math.asin(Math.min(1, Math.sqrt(a)));
  }
  function isBeforeCutoff(now){
    if (!isBiz(now)) return false;
    if (now.getHours() < CUTOFF.hour) return true;
    if (now.getHours() > CUTOFF.hour) return false;
    return now.getMinutes() <= CUTOFF.minute;
  }
  function shipStart(handlingDays){
    var now = new Date();
    var start = isBeforeCutoff(now) ? now : nextBiz(now);
    start = addBiz(start, handlingDays);
    return start;
  }
  function daysFromDistance(mi){
    for (var i=0; i<US_BANDS.length; i++){ if (mi <= US_BANDS[i].max) return US_BANDS[i].days; }
    return 5;
  }
  function fmtDate(d){
    return new Intl.DateTimeFormat('en-US', { weekday:'short', month:'short', day:'numeric' }).format(d);
  }

  // === COUNTDOWN ===
  function cutoffTargetFrom(now){
    var targetDay = (isBeforeCutoff(now) && isBiz(now)) ? now : nextBiz(now);
    var t = new Date(targetDay);
    t.setHours(CUTOFF.hour, CUTOFF.minute, 0, 0);
    return t;
  }

  var __ETA_TIMER__;
  function startCountdown(){
    if (__ETA_TIMER__) clearTimeout(__ETA_TIMER__);

    function tick(){
      var cdEl = document.getElementById('est-countdown');
      if (!cdEl){ __ETA_TIMER__ = setTimeout(tick, 30000); return; }

      var now = new Date();
      if (!isBiz(now)) {
        cdEl.textContent = 'Orders placed today ship next business day';
        __ETA_TIMER__ = setTimeout(tick, 3600000);
        return;
      }

      var target = cutoffTargetFrom(now);
      var diffMs = target - now;

      if (diffMs <= 0){
        cdEl.textContent = 'After '+CUTOFF.label+' — ships next business day';
        __ETA_TIMER__ = setTimeout(tick, 60000);
        return;
      }

      var totalMin = Math.floor(diffMs / 60000);
      var hrs = Math.floor(totalMin / 60);
      var mins = totalMin % 60;
      cdEl.textContent = 'Order within ' + hrs + 'h ' + String(mins).padStart(2,'0') + 'm to ship today (by ' + CUTOFF.label + ')';
      __ETA_TIMER__ = setTimeout(tick, 30000);
    }

    tick();
  }

  // === RENDER ===
  function renderRange(el, zip, earliest, latest){
    var same = ymd(earliest) === ymd(latest);
    var body = same
      ? 'Estimated delivery <strong>'+ fmtDate(earliest) +'</strong> to <strong>'+(zip||'your area')+'</strong>'
      : 'Estimated delivery <strong>'+ fmtDate(earliest) +' – '+ fmtDate(latest) +'</strong> to <strong>'+(zip||'your area')+'</strong>';

    el.innerHTML =
      '<div class="est-delivery-row">' +
        '<span class="est-icon" aria-hidden="true">🚚</span>' +
        '<span>'+ body +'</span>' +
      '</div>' +
      '<div class="est-sub">' +
        'Order by '+ CUTOFF.label +' for earliest ship-out' +
        '<div id="est-countdown" class="est-countdown"></div>' +
        '<button id="change-zip-btn" class="est-btn" type="button">Change ZIP</button>' +
      '</div>';
  }

function renderInput(el){
  el.innerHTML =
    '<div class="est-delivery-row">' +
      '<span class="est-icon" aria-hidden="true">🚚</span>' +
      '<label class="est-inline">Enter your ZIP: ' +
        '<input id="est-zip" type="tel" inputmode="numeric" pattern="[0-9]*" maxlength="5" ' +
        'autocomplete="postal-code" class="est-input" placeholder="Enter ZIP" aria-label="Enter ZIP code" />' +
        '<button id="est-apply" type="button" class="est-btn" aria-label="Apply ZIP">Apply</button>' +
      '</label>' +
    '</div>' +
    '<div class="est-sub">We’ll show your estimated delivery date</div>';

  var inp = document.getElementById('est-zip');
  var btn = document.getElementById('est-apply');

  if (!inp) return;

  // Always ensure editable
  inp.removeAttribute('readonly');
  inp.disabled = false;

  // Keep only digits, max 5
  inp.addEventListener('input', function(){
    this.value = this.value.replace(/\D/g,'').slice(0,5);
  });

  // Stop the product form from swallowing Enter / key events
  inp.addEventListener('keydown', function(e){
    e.stopPropagation();
    if (e.key === 'Enter') {
      e.preventDefault();
      calculate(el, inp.value.trim());
    }
  });

  // Clicking the button applies ZIP
  if (btn) {
    btn.addEventListener('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      calculate(el, inp.value.trim());
    });
  }
}


  // === ZIP / DATA ===
  function assetUrl(name){
    var map = window.__DELIVERY_ASSETS__ || {};
    return map[name];
  }

async function loadZip3(){
  try{
    var url = assetUrl('zip3.json');
    if (!url) throw new Error('zip3 asset url missing');
    var r = await fetch(url, { cache: 'force-cache' });
    if (!r.ok) throw new Error('zip3 fetch '+r.status);
    var j = await r.json();

    // ✅ merge local overrides
    Object.assign(j, ZIP3_OVERRIDES);

    return j;
  }catch(e){
    console.error('[ETA] zip3 load error:', e);
    // fallback if zip3 file missing
    return Object.keys(ZIP3_OVERRIDES).length ? ZIP3_OVERRIDES : null;
  }
}


  async function detectUSZip(){
    var z = (window.__CUSTOMER_ZIP__ || '').trim();
    if (/^\d{5}$/.test(z)) return z;
    try{
      var r = await fetch('https://ipapi.co/json/');
      if (r.ok){
        var j = await r.json();
        if (j && j.country === 'US' && /^\d{5}$/.test(j.postal||'')) return j.postal;
      }
    }catch(e){}
    return '';
  }

  // === MAIN ===
  async function calculate(el, zip){
    try{
      var zip3 = await loadZip3();
      if (!zip3){ el.textContent = 'Estimated delivery shown at checkout'; return; }

      var dest = (zip && /^\d{5}$/.test(zip)) ? zip : await detectUSZip();
      if (!dest){ renderInput(el); return; }

      var z3 = dest.slice(0,3);
      var ll = zip3[z3];
      if (!ll){ renderInput(el); return; }

      var mi = haversineMi(ORIGIN.lat, ORIGIN.lon, ll[0], ll[1]);
      var transit = daysFromDistance(mi);

      var earliest = addBiz(shipStart(HANDLING_MIN_DAYS), transit);
      var latest   = addBiz(shipStart(HANDLING_MAX_DAYS), transit);

      renderRange(el, dest, earliest, latest);
      startCountdown();

      var btn = document.getElementById('change-zip-btn');
      if (btn) btn.addEventListener('click', function(){ renderInput(el); });
    }catch(err){
      console.error('[ETA] calc error:', err);
      el.textContent = 'Estimated delivery shown at checkout';
    }
  }

  // === INIT ===
  function init(){
    var el = document.getElementById('estimated-delivery');
    if (!el) return;
    calculate(el, '');
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
